// extracted by css-extract-rspack-plugin
export default {"authBackgroundImage":"AuthBackgroundImage_authBackgroundImage__+d-Up"};